"use client"

import { ModelShowcaseItemDto } from "api"
import { trackModelsCarouselClick } from "utils/gtm"
import ChevronIcon from "./ChevronIcon"
import { formatPrice } from "./formatPrice"
import {
  Cta,
  CtaCircle,
  DetailsWrap,
  OnlineLink,
  PriceCol,
  PriceDivider,
  PriceGrid,
  PriceLabel,
  PriceNote,
  PriceNum,
  Shekel,
} from "./modelShowcase.styled"

type Props = { model: ModelShowcaseItemDto }

const ModelDetails = ({ model }: Props) => {
  const price = model.price
  const hasPrice = price != null && Number.isFinite(price.priceValue1)

  return (
    <DetailsWrap>
      {hasPrice && (
        <>
          <PriceGrid>
            {/* RTL: first column lands on the right */}
            <PriceCol>
              {price.priceLabel1 && (
                <PriceLabel dir="auto">{price.priceLabel1}</PriceLabel>
              )}
              <PriceNum>
                <Shekel>₪</Shekel>
                {formatPrice(price.priceValue1)}
              </PriceNum>
            </PriceCol>
            {Number.isFinite(price.priceValue2) && (
              <>
                <PriceDivider />
                <PriceCol>
                  {price.priceLabel2 && (
                    <PriceLabel dir="auto">{price.priceLabel2}</PriceLabel>
                  )}
                  <PriceNum>
                    <Shekel>₪</Shekel>
                    {formatPrice(price.priceValue2)}
                  </PriceNum>
                </PriceCol>
              </>
            )}
          </PriceGrid>
          {price.priceNote && (
            <PriceNote dir="auto">{price.priceNote}</PriceNote>
          )}
          {model.onlineUrl && model.onlineLabel && (
            <OnlineLink href={model.onlineUrl} dir="auto">
              {model.onlineLabel}
            </OnlineLink>
          )}
        </>
      )}
      {model.ctaText && (
        <Cta
          href={model.ctaUrl || "#"}
          onClick={() => trackModelsCarouselClick(model.modelName ?? "")}
        >
          <span dir="auto">{model.ctaText}</span>
          <CtaCircle>
            <ChevronIcon size={14} />
          </CtaCircle>
        </Cta>
      )}
    </DetailsWrap>
  )
}

export default ModelDetails
